<template>
    <div>
        <DataTable :value="tableData" stripedRows scrollable class="base-table h-20rem" scrollHeight="20rem" v-model:selection="selectedRow" selectionMode="single" @rowSelect="onRowSelect">
            <template #empty> No data available </template>
            <Column field="group_by" header="" />
            <Column v-for="(col, index) of tableColumns" :field="col.field" :header="col.header" :key="col.field + '_' + index" />
        </DataTable>
        <!-- Static user table for pop up dialog -->
        <StaticUserTable v-if="userListDialog" :header="metricTitle" :userGroupId="userGroupId" @hide-dialog="hideStaticUserTable" />
    </div>
</template>

<script setup>
import StaticUserTable from './StaticUserTable.vue';

import { ref, onMounted, defineProps } from 'vue';
import { useMetricDataStore } from '../../../../../store/metric/metricData';

// Props
const props = defineProps({
    jsonData: Object,
    metricTitle: String,
    userCountFlag: {
        type: Boolean,
        default: false,
    },
});
const metricDataStore = useMetricDataStore();

// states
const userListDialog = ref(false);
const userGroupId = ref(null);

// Table data
const selectedRow = ref(null);
const tableColumns = ref(null);
const tableData = ref(null);

onMounted(() => {
    if (props.jsonData) {
        loadTableData();
    }
});

const loadTableData = async () => {
    const data = await metricDataStore.getDSTabularData(props.jsonData);
    tableData.value = data?.tableData;
    tableColumns.value = data?.tableColumns;
};

const onRowSelect = (event) => {
    // Extract metric id from jsonData
    const metricId = props.jsonData?.metric?.id;
    userListDialog.value = true;
    // If metric id == 5
    if (metricId === 5) {
        // AND Pass is clicked then usergroup => 5
        if (event?.data?.group_by === 'Pass') {
            userGroupId.value = 5;
        }
        // ELSE  FAIL is clicked then usergroup => 6
        else {
            userGroupId.value = 6;
        }
    }
    // ELSE IF metric id === 9 Max one  then usergroupId => 4
    else if (metricId === 9) {
        userGroupId.value = 4;
    }
    // ELSE IF metric id = 10 ==> usergroupId == 7
    else if (metricId === 10) {
        userGroupId.value = 7;
    }
    // ELSE :- if none of the above matches, then dont open dialog, turn it off
    else {
        userListDialog.value = false;
    }
};

const hideStaticUserTable = () => {
    userListDialog.value = false;
    selectedRow.value = null;
};
</script>
